module.exports = "/_next/static/images/5f63bc3f456c6e0ddb6668f5aece6486-cartao-proximo-ao-olho-xs@1x.jpg";